import { LOCALSTORAGE_KEY } from "../config/general"

export const setItem = (key, value) => {
	localStorage.setItem(key, JSON.stringify(value))
}

export const getItem = (key) => {
	let item = localStorage.getItem(key)
	if (item != null && item[key] != null) {
		item = JSON.parse(item[key])
	}
	return item
}

export const removeItem = (key) => {
	localStorage.removeItem(key)
}

export const saveLoginData = (user, nombre, apellido, hash, cuentaId) => {
	setItem(LOCALSTORAGE_KEY, {
		usuario: {
			user,
			nombre,
			apellido,
		},
		hash,
		cuentaId,
	})
}

export const getData = (key) => {
	let data = getItem(LOCALSTORAGE_KEY)

	if (data != null) {
		data = JSON.parse(data)
		data = data[key]
	}
	return data
}
